export type tipoPrimitivo = 'String' | 'Float' | 'Bool' | 'Date' | 'Int' | 'Percent' | 'NumberOrPercent' | 'Money';

type TipoPrimitivoDecoded = {
	[key in tipoPrimitivo]: string;
};

const tipoPrimitivoDecoded: TipoPrimitivoDecoded = {
	String: 'Texto',
	Float: 'Numero decimal',
	Int: 'Numero inteiro',
	Bool: 'Sim/Não',
	Date: 'Data',
	Percent: 'Percentual',
	NumberOrPercent: 'Numero ou percentual',
	Money: 'Dinheiro',
};

export function decodeTipoPrimitivo(tipo: tipoPrimitivo | string): string {
	return tipoPrimitivoDecoded[tipo as tipoPrimitivo] || 'desconhecido';
}

export interface ISolicitacaoTipoFormNovoDto {
	nome: string;
	tipoPrimitivo: tipoPrimitivo;
	descricao?: string;
	tipoSolicitacao: number;
	ordem?: number;
	obrigatorio?: boolean;
}

export interface ISolicitacaoTipoFiltroDto {
	id?: number[];
	nome?: string;
	descricao?: string;
	ativo?: boolean;
	dataCriacaoInicial?: string;
	dataCriacaoFinal?: string;
	usuarioCriadorId?: number[];
	deveIncluir?: Includable[];
	orderBy?: Orderable;
	orderByDesc?: boolean;
	usaContrato?: boolean;
}

type Includable = "Forms" | "UsuarioCriador" | 'Parametros';

type Orderable = "Id" | "Nome" | "Descricao" | "DataCriacao" | "UsuarioCriadorId" | "QuantidadeForms" | "Ativo";


export interface ISolicitacaoTipoNovaDto {
	nome: string;
	descricao?: string;
	form: ISolicitacaoTipoFormNovoDto[];
	parametros: IParametroForm[];
}

interface IParametroForm {
	id: number;
	valor: string;

	// [key: number]: string;
}

export interface ISolicitacaoNovaFormEntryDto {
	formId: number;
	valor: any;
}

export interface ISolicitacaoNovaDto {
	titulo: string;
	tipoSolicitacaoId: number;
	recursoId?: number;
	contratoId?: number;
	contaContabilId?: number;
	form: ISolicitacaoNovaFormEntryDto[];
	itens: ISolicitacaoItemDto[];
}

export interface ISolicitacaoItemDto {
	itemId: number;
	qtd: number;
	valorEstimado?: number;
	observacao?: string;
}